export default {
    init() {
      //
    },

    finalize() {
        window.taxonomyPage = 1;
        jQuery(document).on('click', '.taxonomy-page__next-page', function () {
            window.taxonomyPage += 1;

            jQuery('.taxonomy-page__next-page')
              .attr('disabled', true);

            jQuery.ajax({
                url: window.taxonomyRoute,
                method: 'GET',
                data: {
                    p: window.taxonomyPage,
                },
            }).done(function (response) {
                jQuery('.taxonomy-page__next-page')
                  .attr('disabled', null);

                for (let i = 0; i < response.items.length; i++) {
                    jQuery('.collections-vertical-listing__items')
                    .append('<div class="collections-vertical-listing__item">' + response.items[i] + '</div>');
                }

                if (response.items.length < window.taxonomyPostsPerPage) {
                    jQuery('.taxonomy-page__next-page')
                    .remove();
                }
            });
        });
    },
};
